import { render, staticRenderFns } from "./paymentRecordList.vue?vue&type=template&id=037b5d98&scoped=true"
import script from "./paymentRecordList.vue?vue&type=script&lang=js"
export * from "./paymentRecordList.vue?vue&type=script&lang=js"
import style0 from "./paymentRecordList.vue?vue&type=style&index=0&id=037b5d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b5d98",
  null
  
)

export default component.exports